export interface PrescriptionFormData {
  drugsId: string;
  drugsIds: string;
  doseId: string;
  frequency: string;
  duration: string;
  drugs: string;
  dose: string;
  doseIds: string;
  type: string;
  qty?: number | string;
  dispense?: boolean;
  productId?: string;
  availableStock?: number;
  productScale?: string;
  unitPrice?: number;
  linkedProductName?: string;
  /** How many brands fill this dose (badge only). */
  linkedProductCount?: number;
}

export type PrescriptionFormValidationResult =
  | { valid: true; payload: PrescriptionFormData }
  | { valid: false; message: string };

export const validatePrescriptionForm = (
  formData: PrescriptionFormData
): PrescriptionFormValidationResult => {
  if (
    !formData.drugsId ||
    !formData.doseIds ||
    !formData.frequency ||
    !formData.duration
  ) {
    return {
      valid: false,
      message: "Drugs, dose, frequency and duration are required",
    };
  }

  return { valid: true, payload: formData };
};
